var _rect, _circle, _path, _path2, _path3, _path4, _circle2, _circle3, _path5, _circle4, _circle5, _ellipse, _ellipse2, _ellipse3, _path6, _ellipse4, _circle6, _ellipse5, _circle7, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _rect2, _rect3, _rect4, _rect5, _defs, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#4f7a78"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#648988",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 50C31 22 48 17 60 17S89 22 86 50L88 78C88 84 82 86 77 84H43C38 86 32 84 32 78Z",
    fill: "#4a3426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#7a8a62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88L60 124L70 88C66 92 54 92 50 88Z",
    fill: "#f4eee0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88L60 124M70 88L60 124",
    stroke: "#616e4e",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 102,
    r: 1.5,
    fill: "#616e4e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 112,
    r: 1.5,
    fill: "#616e4e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#d4b090"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#f1c8a4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#f1c8a4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#f1c8a4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#bb9c7f",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48Q51 44 56 47",
    stroke: "#4a3426",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48Q69 44 74 47",
    stroke: "#4a3426",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52 67Q60 75 68 67",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50C34 27 48 21 60 21S86 27 83 50L80 45C74 41 66 39 62 31C54 37 44 39 40 45Z",
    fill: "#4a3426"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42 40C48 36 54 38 58 33M66 34C72 38 76 38 80 42",
    stroke: "#37271c",
    strokeWidth: 1.6,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 0.18,
    stroke: "#3b3b4a",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 54,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 54,
    r: 7.5
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 53Q60 51.5 61.5 53M43.5 53L38 51M76.5 53L82 51",
    stroke: "#3b3b4a",
    strokeWidth: 2,
    fill: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56C32 24 50 14 60 14S88 24 84 56",
    stroke: "#2f3a46",
    strokeWidth: 5,
    fill: "none",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 50,
    width: 9,
    height: 18,
    rx: 4.5,
    fill: "#5a4a3c"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 50,
    width: 9,
    height: 18,
    rx: 4.5,
    fill: "#5a4a3c"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 53,
    width: 3,
    height: 12,
    rx: 1.5,
    fill: "#43372d"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 53,
    width: 3,
    height: 12,
    rx: 1.5,
    fill: "#43372d"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: "50%",
    cy: "48%",
    r: "72%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#2a1a08",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a1a08",
    stopOpacity: 0.38
  })))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#8a6a3a",
    opacity: 0.12
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "url(#v)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait23);
export default __webpack_public_path__ + "static/media/player-portrait-23.6b0415a0dd3ddef75f5cf44c39ac1007.svg";
export { ForwardRef as ReactComponent };